import { useFeature } from 'src/core/common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';
import { useCompanyCurrency } from 'src/core/modules/app/hooks/useCompanyCurrency';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

import { useGetWiseKycStatus } from './useGetWiseKycStatus';
import { useFetchKycRemediation } from '../../../hooks/useFetchKycRemediation';

export const useIsIwtEnabled = () => {
  const companyCurrency = useCompanyCurrency();
  const companyId = useCompanyId();

  const hasEEAInternationalWiretransferFeature = useFeature(
    FEATURES.TMP_EEA_INTERNATIONAL_WIRE_TRANSFER,
  );

  const hasUKInternationalTransferFeature = useFeature(
    FEATURES.TMP_UK_INTERNATIONAL_WIRE_TRANSFER,
  );

  const fetchKycRemediationResult = useFetchKycRemediation({
    isEnabled: companyCurrency === 'EUR',
  });

  const { data: kycStatus } = useGetWiseKycStatus({
    companyId,
    enabled: companyCurrency === 'GBP' && hasUKInternationalTransferFeature,
  });

  if (companyCurrency === 'GBP' && hasUKInternationalTransferFeature) {
    return kycStatus === 'PASSED';
  }

  return (
    companyCurrency === 'EUR' &&
    hasEEAInternationalWiretransferFeature &&
    fetchKycRemediationResult.status === 'success' &&
    fetchKycRemediationResult.data.status === 'approved'
  );
};
